import Highcharts from 'highcharts';

const categories = ["2015", "2019", "2020"];

export const figure7 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },
    plotOptions: {
        series: {
            borderWidth: 0,
            stacking: 'normal',
        }
    },
    exporting: {
        enabled: false
    },
    xAxis: [{
        tickWidth: 0,
        labels: {
            groupedOptions: [{
                        style: {
                            transform: 'unset'
                        },
                  }],
            style: {
                transform: 'translateX(11px)'
            },
            align: 'right'
        },
        categories: [
            {
                name: "Mundo",
                categories: categories
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "Oceanía",
                categories: categories
            },
            {
                name: "",
                categories: [''] 
            },
            {
                name: "África<br />subsahariana",
                categories: categories
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "América del Norte y<br />Europa",
                categories: categories
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Asia oriental y<br />Asia sudoriental",
                categories: categories
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Asia central y<br />Asia meridional",
                categories: categories
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "América Latina y<br />el Caribe",
                categories: categories
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "África septentrional y<br />Asia occidental",
                categories: categories
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Países menos<br />adelantados",
                categories: categories
            },
               {
                name: "",
                categories: [''] 
            },
            {
                name: "Países en desarrollo<br />sin litoral",
                categories: categories
            },
        ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
    }],
    yAxis: [{
        labels: {
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        format: '{value}%',
        gridLineWidth: 2,
        floor: 0,
        ceiling: 70,
        tickInterval: 10,
        title: {
            text: '%',
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        valueSuffix: '%',
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    series: [{
        name: 'Moderadas',
        color: '#ed7d31',
        data: [ 14.6569722, 16.46427571, 18.4817377, null,
                7.328793804, 9.782867074, 9.444230949, null,
                32.59583848, 35.00974864, 36.65711297, null,
                7.95304447, 6.621429722, 7.380512348, null,
                7.354428483, 8.436175328, 8.541943222, null,
                15.73463101, 19.03625788, 23.47077531, null,
                20.06757614, 21.85372028, 26.66347062, null,
                18.18298497, 19.55303839, 20.02886141, null,
                27.61892566, 32.45820743, 30.95840286, null,
                29.17784929, 32.05786423, 31.53761499 ]
    }, {
        name: 'Grave',
        color: '#cc3300',
        data: [ 8.108633127, 10.11140678, 11.90051657, null,
            2.637475462, 3.837267364, 2.581180331, null,
            20.41329237, 24.90076976, 29.53549241, null,
            1.366326013, 1.044632563, 1.427791783, null,
            1.149814928, 1.652490463, 2.381828275, null,
            14.32446469, 17.67186525, 19.3744052, null,
            7.462730257, 10.07721189, 14.19035488, null,
            8.770196051, 8.772335334, 9.188617351, null,
            15.90751044, 18.73691491, 22.22101085, null,
            20.2716968, 21.91088163, 23.79299879 ]
    }]
}
